import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { urlEndPoints } from '../config/end-points';

@Injectable({
  providedIn: 'root',
})
export class CalendarDal {
  constructor(private httpClient: HttpClient) {}

  getDayCoverageEtp(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    showHourlyVolume: boolean,
    isBreakTimeIncludedInStats: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'dayCoverageEtp?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint +=
      '&includeWeekends=' +
      includeWeekends +
      '&showHourlyVolume=' +
      showHourlyVolume +
      '&isBreakTimeIncludedInStats=' +
      isBreakTimeIncludedInStats;
    return this.httpClient.get<any>(endpoint);
  }

  getNightCoverageEtp(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    showHourlyVolume: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'nightCoverageEtp?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint += '&includeWeekends=' + includeWeekends + '&showHourlyVolume=' + showHourlyVolume;
    return this.httpClient.get<any>(endpoint);
  }

  getTempStaffCount(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    showHourlyVolume: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'tempStaffCount?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint += '&includeWeekends=' + includeWeekends + '&showHourlyVolume=' + showHourlyVolume;
    return this.httpClient.get<any>(endpoint);
  }

  getDayWorkloadRate(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'dayWorkloadRate?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint += '&includeWeekends=' + includeWeekends;
    return this.httpClient.get<any>(endpoint);
  }

  getNightWorkloadRate(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'nightWorkloadRate?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint += '&includeWeekends=' + includeWeekends;
    return this.httpClient.get<any>(endpoint);
  }

  getAbsenceCount(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    showHourlyVolume: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'absenceCount?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint += '&includeWeekends=' + includeWeekends + '&showHourlyVolume=' + showHourlyVolume;
    return this.httpClient.get<any>(endpoint);
  }

  getCoverageEtpByWeekDays(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    showHourlyVolume: boolean,
    isBreakTimeIncludedInStats: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'coverageEtpByWeekDays?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint +=
      '&includeWeekends=' +
      includeWeekends +
      '&showHourlyVolume=' +
      showHourlyVolume +
      '&isBreakTimeIncludedInStats=' +
      isBreakTimeIncludedInStats;
    return this.httpClient.get<any>(endpoint);
  }

  getCoverageEtpBySpecialties(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    showHourlyVolume: boolean,
    isBreakTimeIncludedInStats: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'coverageEtpBySpecialties?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }

    endpoint +=
      '&includeWeekends=' +
      includeWeekends +
      '&showHourlyVolume=' +
      showHourlyVolume +
      '&isBreakTimeIncludedInStats=' +
      isBreakTimeIncludedInStats;
    return this.httpClient.get<any>(endpoint);
  }

  getCodesCountByProfiles(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    campaignId?: string,
    scenarioId?: string
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'codesCountByProfiles?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint += '&includeWeekends=' + includeWeekends;

    if (campaignId && scenarioId) {
      endpoint += '&campaignId=' + campaignId + '&scenarioId=' + scenarioId;
    }
    return this.httpClient.get<any>(endpoint);
  }

  getSkillsAnalyticsBySpecialties(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    showHourlyVolume: boolean,
    isBreakTimeIncludedInStats: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'skillsAnalyticsBySpecialties?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }

    endpoint +=
      '&includeWeekends=' +
      includeWeekends +
      '&showHourlyVolume=' +
      showHourlyVolume +
      '&isBreakTimeIncludedInStats=' +
      isBreakTimeIncludedInStats;
    return this.httpClient.get<any>(endpoint);
  }

  getMeanDaysToLevel3(
    fromDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'meanDaysToLevel3?fromDate=' + fromDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint += '&includeWeekends=' + includeWeekends;
    return this.httpClient.get<any>(endpoint);
  }

  getCoverageEtpBySurgeons(
    fromDate: string,
    toDate: string,
    populationId: string | undefined,
    formations: string | undefined,
    includeWeekends: boolean,
    showHourlyVolume: boolean,
    isBreakTimeIncludedInStats: boolean
  ): Observable<any> {
    let endpoint = urlEndPoints.calendars + 'coverageEtpBySurgeons?fromDate=' + fromDate + '&toDate=' + toDate;
    if (populationId) {
      endpoint += '&populationId=' + populationId;
    }
    if (formations) {
      endpoint += '&formations=' + formations;
    }
    endpoint +=
      '&includeWeekends=' +
      includeWeekends +
      '&showHourlyVolume=' +
      showHourlyVolume +
      '&isBreakTimeIncludedInStats=' +
      isBreakTimeIncludedInStats;
    return this.httpClient.get<any>(endpoint);
  }
}
